import {
  BASEMAP_ADDON_GIS,
  BASEMAP_ESRI_NAVIGATION_DARK,
  BASEMAP_ESRI_NAVIGATION_LIGHT,
  BASEMAP_GOOGLE_ROADMAP,
} from '@rsos/constants/basemapAddonNames';
import { ESRI, GOOGLE } from '@rsos/constants/mapProviders';
import capitalizeFirstLetter from '@rsos/utils/capitalizeFirstLetter';
import AddonGIS from './assets/addon-gis.webp';
import BasemapEsri from './assets/basemap-esri.webp';
import BasemapGoogle from './assets/basemap-google.webp';
import BasemapNone from './assets/basemap-none.webp';

export const defaultBasemaps = [
  {
    backgroundImage: BasemapGoogle,
    basemaps: {
      dark: BASEMAP_GOOGLE_ROADMAP,
      light: BASEMAP_GOOGLE_ROADMAP,
    },
    displayName: capitalizeFirstLetter(GOOGLE),
    id: `${GOOGLE}-${BASEMAP_GOOGLE_ROADMAP}`,
    isBasemapVisible: true,
    mapProvider: GOOGLE,
  },
  {
    backgroundImage: BasemapEsri,
    basemaps: {
      dark: BASEMAP_ESRI_NAVIGATION_DARK,
      light: BASEMAP_ESRI_NAVIGATION_LIGHT,
    },
    displayName: capitalizeFirstLetter(ESRI),
    id: `${ESRI}-${BASEMAP_ESRI_NAVIGATION_LIGHT}`,
    isBasemapVisible: true,
    mapProvider: ESRI,
  },
];

export const noneBasemap = {
  backgroundImage: BasemapNone,
  basemaps: {
    dark: BASEMAP_ESRI_NAVIGATION_DARK,
    light: BASEMAP_ESRI_NAVIGATION_LIGHT,
  },
  displayName: 'None',
  id: `${ESRI}-none`,
  isBasemapVisible: false,
  mapProvider: ESRI,
};

export const addons = [
  {
    backgroundImage: AddonGIS,
    displayName: BASEMAP_ADDON_GIS.toUpperCase(),
    id: BASEMAP_ADDON_GIS,
    name: BASEMAP_ADDON_GIS,
  },
];
